import { Form, Select, Typography } from "antd";
import { usePrevious } from "common/customHooks";
import { showError } from "common/ToastNotifications";
import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

const { Text } = Typography;
const { Option } = Select;

function BusinessAreaSelectFormItem({ form, getUserBusinessAreas, getUserBusinessAreasResult, businessAreas, formItemProps, disabled, onChange }) {
    const [fetchingBusinessAreas, setFetchingBusinessAreas] = useState(false);
    const previousGetUserBusinessAreasResult = usePrevious(getUserBusinessAreasResult);
    const [businessAreaDict, setBusinessAreaDict] = useState({});

    useEffect(() => {
        if (!businessAreas || businessAreas.length === 0) {
            setFetchingBusinessAreas(true);
            getUserBusinessAreas();
        } else {
            const businessAreaDict = {};
            if (businessAreas && businessAreas.length > 0) {
                for (let businessArea of businessAreas) {
                    businessAreaDict[businessArea.businessAreaId] = businessArea;
                }
            }
            if (form) {
                const businessAreaId = form.getFieldValue(formItemProps.name);
                if (businessAreaId) {
                    onChange(businessAreaId, businessAreaDict[businessAreaId]);
                }
            }
            setBusinessAreaDict(businessAreaDict);
            setFetchingBusinessAreas(false);
        }
    }, [businessAreas, getUserBusinessAreas, form, onChange, formItemProps]);

    useEffect(() => {
        if (getUserBusinessAreasResult && getUserBusinessAreasResult !== previousGetUserBusinessAreasResult) {
            if (!getUserBusinessAreasResult.success) {
                if (getUserBusinessAreasResult.code === "PERMISSION_DENIED") {
                    showError("Business Areas permission denied.");
                } else {
                    showError("Unable to get Business Areas at this moment.");
                }
            }
            setFetchingBusinessAreas(false);
        }
    }, [getUserBusinessAreasResult, businessAreas, previousGetUserBusinessAreasResult]);

    const onBusinessAreaChange = useCallback(
        (businessAreaId) => {
            if (onChange && businessAreaDict[businessAreaId]) {
                onChange(businessAreaId, businessAreaDict[businessAreaId]);
            }
        },
        [businessAreaDict, onChange],
    );

    return (
        <Form.Item {...formItemProps}>
            <Select placeholder="Please select business area" loading={fetchingBusinessAreas} onChange={onBusinessAreaChange} disabled={disabled}>
                {businessAreas.map((businessArea) => (
                    <Option key={businessArea.businessAreaId} value={businessArea.businessAreaId}>
                        {businessArea.name}
                    </Option>
                ))}
            </Select>
        </Form.Item>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        businessAreas: state.home.businessAreas,
        getUserBusinessAreasResult: state.home.getUserBusinessAreasResult,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserBusinessAreas: () => dispatch(actions.getUserBusinessAreasRequest()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusinessAreaSelectFormItem));
